// Comma-separated allowlist of emails (env-configured) that can bypass AAD auth
// even when global bypass is off, e.g. for local testing against a shared backend.
const bypassEmails = (import.meta.env.VITE_AUTH_BYPASS_EMAILS ?? '')
	.split(',')
	.map((value: string) => value.trim().toLowerCase())
	.filter((value: string) => value.length > 0);

/** Whether authentication is globally bypassed (local/dev builds only). */
export const isAuthBypassEnabled = import.meta.env.VITE_BYPASS_AUTH === 'true';

/**
 * Determine whether a given signed-in account should bypass normal
 * authentication/authorization checks.
 * @param account - The MSAL account (or a minimal shape with username/claims), if any.
 * @returns True if global bypass is enabled, or the account's email/UPN is in the bypass allowlist.
 */
export function isUserBypassEnabled(account?: { username?: string; idTokenClaims?: unknown }): boolean {
	if (isAuthBypassEnabled) {
		return true;
	}

	if (bypassEmails.length === 0 || !account) {
		return false;
	}

	const claims = (account.idTokenClaims ?? {}) as {
		preferred_username?: string;
		email?: string;
		upn?: string;
	};

	const candidates = [
		account.username,
		claims.preferred_username,
		claims.email,
		claims.upn,
	]
		.map((value) => value?.trim().toLowerCase())
		.filter((value): value is string => Boolean(value));

	return candidates.some((value) => bypassEmails.includes(value));
}
